export default "__VITE_ASSET__fefc6e7f__"